import { Component} from '@angular/core';
import { NestedTreeControl } from '@angular/cdk/tree';
import { IBusinessSolution } from 'src/app/interfaces/IBusinessSolution';
import { CorporationService } from 'src/app/services/corporation/corporation.service';
import { EventService } from 'src/app/services/event/event.service';
import { to64decode, to64encode} from "../../helpers/base64";
import { CookieService } from "ngx-cookie-service";
import { getLanguageCookie } from 'src/assets/language';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { systemPermissionsNew } from 'src/app/helpers/systemPermissions';
import { localStorageToJsonAsync } from 
 "../../helpers/cookieToJson";
import { TreeNode } from 'primeng/api';
import { filterArraySubstringTree } from '../../helpers/filterArraySubstringTree';
import { NavigationService } from 'src/app/services/navigation/navigation.service';
// import { AdminGroup } from 'src/app/app.module';

export enum AdminGroup {
  MASTER = 'MASTER',//Administrador do Sistema
  ENVIRONMENT = 'ENVIRONMENT',//Administrador do Ambiente
  OTHERS = 'OTHERS'//Usuários da corporação
}

@Component({
  selector: 'app-corporation',
  templateUrl: './corporation.component.html',
  styleUrls: ['./corporation.component.scss'],
})

export class CorporationComponent {
  properties: any = {}
  parameters: any = {}
  protected readonly AdminGroup = AdminGroup;

  private subscription: Subscription = new Subscription();

  isShowFoundationCreate: boolean = false;
  isShowFoundationEdit: boolean = false;
  isShowFoundationDelete: boolean = false;
  isShowDimensionEdit: boolean = false;

  corporationTree?: any;
  selectedNode: any;
  isSelectedNode = false;
  searchText: string = '';

  text: string = ''
  filterArray: any = []
  filterCursor: number = 0
  isSearch: boolean = false
  selectedFile: any;

  isTreeEmpty = true;
  corporation_parent = []

  corporation = []

  files!: TreeNode[];
  noData = true;

  selectedCorporation: any = { name: 'Loading...' };

  // treeControl = new NestedTreeControl<IBusinessSolution>((node: any) => node.info);
  // dataSource = new MatTreeNestedDataSource<IBusinessSolution>();

  isLoading: boolean = false;
  openTree: boolean = false

  constructor(
    private corporationService: CorporationService,
    private navigationService: NavigationService
  ) {

  }

  async ngOnInit() {
    this.properties = await localStorageToJsonAsync()
    await this.getCorporationTree()
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  getLanguages(file: string){
    return getLanguageCookie(file, localStorage.getItem('language'))
  }

  isShowDelete(uuid: string): boolean{
    if(uuid == this.properties?.corporation?.uuid){
      return false
    }
    return true
  }

  toggleFoundationModal(event?: Event, node?: any) {
    this.isShowFoundationCreate = !this.isShowFoundationCreate;
    if (!node) {
      return;
    }

    this.parameters = {}
    this.parameters.is_principal = node.is_principal;
    this.parameters.reference_parent = node;

    if(event){
      event.stopPropagation();
    }

    delete this.selectedFile
  }

  toggleFoundationModalEdit(event?: Event, node?: any) {
    this.isShowFoundationEdit = !this.isShowFoundationEdit;
    if (!node) {
      return;
    }

    this.parameters = node;

    if(event){
      event.stopPropagation();
    }

    delete this.selectedFile
  }

  toggleFoundationModalDelete(event?: Event, node?: any) {
    this.isShowFoundationDelete = !this.isShowFoundationDelete;
    if (!node) {
      return;
    }

    this.parameters = node;

    if(event){
      event.stopPropagation();
    }

    delete this.selectedFile
  }

  toggleDimensionModalEdit(event?: Event, node?: any) {
    this.isShowDimensionEdit = !this.isShowDimensionEdit
    if (!node) {
      return;
    }

    this.parameters = {}
    this.parameters.corporation = node;

    if(event){
      event.stopPropagation();
    }

    delete this.selectedFile
  }

  searchNodes(): void {
    // this.files = this.filesOld.filter((node) => this.filterNode(node, this.text, true));
    // this.verifyNoData()
    this.filterCursor = 0;
    this.isSearch = true
    this.filterArray = filterArraySubstringTree(this.files, this.text, 'label')
    this.next()
  }

  next() {
    if (this.filterCursor < this.filterArray.length) {
      this.filterCursor++;
      this.scrollToNode(this.filterArray[this.filterCursor - 1]);
    }
  }

  previous() {
    if (this.filterCursor > 1) {
      this.filterCursor--;
      this.scrollToNode(this.filterArray[this.filterCursor - 1]);
    }
  }

  scrollToNode(uuid: string) {
    const node = this.findNodeByUUID(this.files, uuid); // Procura o nó na árvore
    if (node) {
      this.selectedFile = node; // Define o nó selecionado
      this.expandParentNodes(node); // Expande os nós pais, se necessário

      setTimeout(() => {
        const element = document.getElementById(uuid);
        if (element) {
            element.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }, 0)
    }
  }

  // Função para expandir todos os nós pais para garantir que o nó esteja visível
  expandParentNodes(node: any) {
    let parentNode = this.findNodeByUUID(this.files, node.master); // Encontra o pai usando `master`
    while (parentNode) {
      parentNode.expanded = true;  // Expande o nó pai
      parentNode = this.findNodeByUUID(this.files, parentNode.master); // Move para o próximo nó pai
    }
  }

  // Função recursiva para encontrar um nó pelo UUID na árvore
  findNodeByUUID(nodes: any[], uuid: string): any {
    for (let node of nodes) {
      if (node.uuid === uuid) {
        return node;
      }
      if (node.children) {
        const found = this.findNodeByUUID(node.children, uuid);
        if (found) return found;
      }
    }
    return null;
  }

  clearFilter(){
    this.isSearch = false; 
    this.filterArray = [];
    this.text = ''
  }

  async getCorporationTree() {
    // this.dataSource.data = [];
    this.isLoading = true;

    this.subscription.add(
      this.corporationService.getCorporationTree({ search: '' })
        .subscribe(
          (response: any) => {
            if (response && response.data && response.data.result) {
                // this.dataSource = response.data.result;
                this.files = sortTreeNodes(response.data.result)
                this.noData = response.data.result.length == 0;
                if(!this.files[0].expanded){
                  this.expandAll()
                }
            }else {
              throw new Error('Erro ao consultar àrvore de corporations!\nConsulta o administrador do sistema!');
            }
          },
          (error) => {
            console.error(error);
          }
        )
    );
    this.isLoading = false;
  }

  buildTreeData(nodes: any[]): any[] {
    return nodes.map((node) => {
      const children = node.info ? this.buildTreeData(node.info) : [];
      return {
        ...node,
        info: children
      };
    });
  }

  choseDomainTree(corporation: any) {
    this.corporation = corporation.slug;
    this.corporationTree = undefined
    this.selectedCorporation.name = corporation.name;
  }

  hasChild = (_: number, node: IBusinessSolution) => !!node.info && node.info.length > 0;

  async expandedNode(node: any) {
    if (node.is_corporation) {
      this.corporationTree = node;
    }
  }

  async selectNode(node: any = {}, show = true) {
    this.selectedNode = node;
    if (node == '') {
      this.isSelectedNode = false;
    } else {
      this.isSelectedNode = show;
    }
  }

  collapseRecursive(nodes: any, treeControl: NestedTreeControl<any>) {
    for (const node of nodes) {
      if (treeControl.isExpanded(node)) {
        treeControl.collapse(node);
      }
      if (node.info && node.info.length > 0) {
        this.collapseRecursive(node.info, treeControl);
      }
    }
  }


  async navigate (node: any, route: string) {
    const corporation = {
      uuid: node.uuid,
      name: node.name,
      corporation_name: node.corporation_name,
      slug: node.slug,
      is_active: node.is_active,
      is_matriz: node.is_matriz,
      is_principal: node.is_principal,
      environment_uuid: node.environment_uuid,
      corporation_uuid: node.corporation_uuid
    }

    localStorage.removeItem('corporation')
    localStorage.setItem('corporation', to64encode(corporation))

    if (to64decode(localStorage.getItem('corporation'))) {
      this.navigationService.navigate(route)
    }
  }

  getSystemPermission(screen: string, action: string){
    return systemPermissionsNew(screen, action)
  }

  async flipTree(){
    this.openTree = !this.openTree;
    if(this.openTree){
      return this.expandAll()
    }
    return this.collapseAll()
  }


  async expandAll() {
    this.files.forEach((node) => {
      this.expandRecursive(node, true);
    });
  }

  async collapseAll() {
    this.files.forEach((node) => {
      this.expandRecursive(node, false);
    });
  }

  expandRecursive(node: TreeNode, isExpand: boolean) {
    node.expanded = isExpand;
    if (node.children) {
      node.children.forEach((childNode) => {
        this.expandRecursive(childNode, isExpand);
      });
    }
  }

  getParentCount(node: any): number {
    let parentCount = 0;
    let parentNode = node;

    while (parentNode && parentNode.parent) {
      parentCount++;
      parentNode = parentNode.parent;
    }

    // Adicione 1 para incluir o próprio nó na contagem
    return parentCount + 1;
  }

  getClass(node: any): string{
    switch (this.getParentCount(node)) {
      case 1: return 'fas fa-city';
      default: return 'fas fa-building'
    }
  }

  isFirstColumn(node: any): boolean {
    if(node.parent == undefined){
      return true
    }
    return false
  }

  haveAccess(uuid: any, screen?: any, action?: any): boolean{
    let flag = false;

    if(this.properties?.me?.is_admin_master){
      return true
    }

    if(this.properties?.profile?.type == 'environment' && this.getSystemPermission(screen, action)){
      return true
    }

    else {
      if(this.properties?.users_corporations?.corporations){  
        this.properties?.users_corporations?.corporations?.forEach((item: any) => {
          if (item.profile && Object.keys(item.profile).length > 0) {
          JSON.parse(item.profile.permissions).forEach((permission: any) => {
            if(item.uuid == uuid && permission['screen'] == screen){
              flag = true
              return
            }
            });
          }
        });
      }
    }

    return flag
  }
}

export function sortTreeNodes(tree: TreeNode[]): TreeNode[] {
  tree.forEach(node => {
    if (node.children && node.children.length > 0) {
      node.children.sort((a, b) => (a.label || '').localeCompare(b.label || ''));
      sortTreeNodes(node.children);
    }
  });

  return tree.sort((a, b) => (a.label || '').localeCompare(b.label || ''));
}